module.exports = __webpack_public_path__ + "img/header-4.1e4d9ed.jpg";